import { useHistory } from 'react-router';

import Routes from 'app/routes';
import client from 'graphql/apollo/client';

import { ApolloProvider } from '@apollo/client';
import { ConfirmProvider } from 'ui/contexts/overlay/Confirm';
import { LoadingProvider } from 'ui/contexts/overlay/Loading';
import { ToastContextProvider } from 'ui/contexts/overlay/Toast';
import { useAuth } from 'auth/contexts/Auth';

export default function App() {
  const { push } = useHistory();
  const { token, logout } = useAuth();

  return (
    <ApolloProvider client={client(token, logout, push)}>
      <ToastContextProvider>
        <LoadingProvider>
          <ConfirmProvider>
            <Routes />
          </ConfirmProvider>
        </LoadingProvider>
      </ToastContextProvider>
    </ApolloProvider>
  );
}
